import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { GET_WISH_LIST } from '../../graphql/queries/wishlistQueries';
import { getCloudFrontImageUrl } from '../../util/cloudFrontUtils';

const processWishlistStudioImages = (studio) => {
  if (!studio) return studio;

  const images = Array.isArray(studio.images) ? studio.images : [];
  const processedImages = images.map((imageKey) => {
    if (!imageKey) return '';

    return getCloudFrontImageUrl(imageKey, {
      width: 600,
      height: 450,
      fit: 'cover'
    });
  });

  return {
    ...studio,
    images,
    processedImages,
    originalImages: [...images],
    hasImages: processedImages.length > 0
  };
};

export const useFetchWishlist = (wishListID) => {
  const { data, loading, error } = useQuery(GET_WISH_LIST, {
    variables: { id: wishListID },
    skip: !wishListID,
    fetchPolicy: 'cache-and-network',
  });

  const processedWishlist = useMemo(() => {
    if (!data?.getWishList) return null;
    
    const wishlist = { ...data.getWishList };
    const wishListStudioItems = wishlist.wishListStudios?.items;

    if (Array.isArray(wishListStudioItems)) {
      wishlist.wishListStudios = {
        ...wishlist.wishListStudios,
        items: wishListStudioItems.map((item) => {
          if (!item) return item;

          return {
            ...item,
            studio: processWishlistStudioImages(item.studio)
          };
        })
      };
    }

    return wishlist;
  }, [data]);

  return {
    wishlistData: processedWishlist,
    loading,
    error
  };
};
